document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.main-article').forEach((section) => {
    const links = Array.from(section.querySelectorAll('.main-article__toc-link'));
    if (!links.length) return;

    const pairs = links
      .map((link) => {
        const id = decodeURIComponent((link.getAttribute('href') || '').replace('#', ''));
        const target = id && document.getElementById(id);
        return target ? { link, target } : null;
      })
      .filter(Boolean);

    if (!pairs.length) return;

    const setActive = (activeLink) => {
      links.forEach((link) => {
        link.classList.toggle('main-article__toc-link--active', link === activeLink);
      });
    };

    // A heading is active once its top has reached the line it scrolls to when
    // its TOC link is clicked (its scroll-margin-top), plus a small tolerance.
    const TOLERANCE = 16;
    let ticking = false;
    // After a TOC click the clicked link stays active until the user scrolls
    // themselves: near the end of the article the page can't scroll far enough
    // for the last headings to reach the line.
    let clickedLink = null;

    const updateActive = () => {
      ticking = false;
      if (clickedLink) return;

      let active = null;
      pairs.forEach((pair) => {
        const offset = parseFloat(getComputedStyle(pair.target).scrollMarginTop) || 0;
        if (pair.target.getBoundingClientRect().top <= offset + TOLERANCE) active = pair;
      });

      setActive(active ? active.link : null);
    };

    ['wheel', 'touchstart', 'keydown'].forEach((type) => {
      window.addEventListener(
        type,
        () => {
          clickedLink = null;
        },
        { passive: true },
      );
    });

    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(updateActive);
      },
      { passive: true },
    );

    pairs.forEach(({ link }) => {
      link.addEventListener('click', () => {
        clickedLink = link;
        setActive(link);
      });
    });

    updateActive();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const texts = document.querySelectorAll('.recipe-inline-card__card--with-image .recipe-inline-card__text');
  if (!texts.length) return;

  const desktop = window.matchMedia('(min-width: 750px)');

  const clamp = (text) => {
    if (!desktop.matches) {
      text.style.removeProperty('--recipe-text-lines');
      return;
    }
    const lineHeight = parseFloat(getComputedStyle(text).lineHeight);
    if (!lineHeight) return;
    const lines = Math.max(1, Math.floor(text.clientHeight / lineHeight));
    text.style.setProperty('--recipe-text-lines', lines);
  };

  const observer = new ResizeObserver((entries) => {
    entries.forEach((entry) => clamp(entry.target));
  });

  texts.forEach((text) => {
    observer.observe(text);
    clamp(text);
  });
});
